import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './LogoutPage.css';

const LogoutPage = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [phase, setPhase] = useState('out'); // 'out' | 'see-you'

  useEffect(() => {
    if (!user) {
      // Already logged out, just redirect after animation
      const t = setTimeout(() => navigate('/'), 1500);
      return () => clearTimeout(t);
    }

    // Start logout process
    logout().then(() => {
      setPhase('see-you');
      const t = setTimeout(() => navigate('/'), 2000);
      return () => clearTimeout(t);
    });
  }, [user, logout, navigate]);

  return (
    <div className="ff-logout-page">
      <div className="ff-logout-content">
        <div className="ff-logout-logo-wrap">
          <img src="/fodyfee_logo.png" alt="FodyFee" className="ff-logout-logo" />
          <div className="ff-logout-ring"></div>
        </div>
        <h2 className="ff-logout-title">
          {phase === 'out' ? 'Logging out...' : 'See you soon!'}
        </h2>
        <p className="ff-logout-subtitle">
          {phase === 'out'
            ? 'We are securely ending your session'
            : 'Thanks for visiting FodyFee'}
        </p>
      </div>
    </div>
  );
};

export default LogoutPage;
